<template>
  <div class="disposalPlan">
    <div v-if="eventInfo.currentLink === 3 && curRole === '县中心管理人员'">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="选择预案" prop="choosePlan">
          <Select transfer v-model="formValidate.choosePlan" placeholder="请选择预案">
            <Option v-for="(item, index) in planList" :value="item.planName" :key="index">{{ item.planName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="处置方案" prop="disposalPlan">
          <Input v-model="formValidate.disposalPlan" type="textarea" :autosize="{minRows: 5}"
                 placeholder="请填写处置方案"></Input>
        </FormItem>
      </Form>

      <div style="text-align: center">
        <!--      <Button type="primary" @click="">是否请求支援</Button>-->
        <Button type="primary" @click="handleSubmit('formValidate')">提交
        </Button>
        <Button @click="handleReset('formValidate')" style="margin-left: 8px">
          重置
        </Button>
      </div>
    </div>

    <div v-else>
      <el-descriptions class="margin-top" size="medium" :column="1" border
                       :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
        <el-descriptions-item label="选择预案">
          {{ formValidate.choosePlan }}
        </el-descriptions-item>
        <el-descriptions-item label="处置方案">
          {{ formValidate.disposalPlan }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  name: "disposalPlan",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      planList: [],
      formValidate: {
        choosePlan: '',
        disposalPlan: ''
      },
      ruleValidate: {
        choosePlan: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        disposalPlan: [
          {required: true, message: '必填', trigger: 'blur'}
        ]
      },
      curRole: ''
    }
  },
  mounted() {
    this.getUserData()
    this.getPlanList()
    // this.getEmergencyTeams(1)
    // this.getInvokeResource()
    // this.getEmergencyBase()
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo()
    }
  },
  methods: {
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
    formatInfo() {
      // console.log(this.stepInfo)
      let info = this.stepInfo.split(';')
      // console.log(info)
      info.forEach(item => {
        const obj = item.split('_')
        this.formValidate[obj[0]] = obj[1]
      })
    },
    // 获取预案
    getPlanList() {
      let params = {}
      this.$http.post('/api/getPlanList', params).then(res => {
        // console.log(res)
        this.planList = res.data.data
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let params = {
            currentLink: this.eventInfo.currentLink,
            indexCode: this.eventInfo.deptIndexCode,
            information: `choosePlan_${this.formValidate.choosePlan};disposalPlan_${this.formValidate.disposalPlan}`,
            messageId: this.eventInfo.id,
            eventLevel: this.eventInfo.eventLevel
          }
          console.log(params)
          // if (this.formValidate.sendingMethod === '1') {
          //   this.$http.post('/api/jumpPreLink', params).then(res => {
          //     console.log(res)
          //     this.$emit('refreshStep')
          //   })
          // } else {
          this.$http.post('/api/jumpNextLink', params).then(res => {
            console.log(res)
            this.$emit('refreshStep')
          })
          // }
          this.$Message.success('提交成功!');
        } else {
          this.$Message.error('请填写!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    pageChangeTeamCan(page) {
      this.currentPageTeamCan = page
    },
    pageSizeChangeTeamCan(pageSize) {
      this.pageSizeTeamCan = pageSize
    },
    pageChangeResCan(page) {
      this.currentPageTeamCan = page
    },
    pageSizeChangeResCan(pageSize) {
      this.pageSizeTeamCan = pageSize
    },
    deleteSelTeam(row, index) {
      this.teamData.splice(index, 1)
      // this.selTeam = this.teamData
    },
    deleteSelResource(row, index) {
      this.resouData.splice(index, 1)
      // this.selResource = this.selResource
    },
  }
}
</script>

<style scoped lang="less">
.disposalPlan {
  width: 60%;
  margin: 0 auto;
}
</style>
